import { render, staticRenderFns } from "./ModalFormularioEstablecerProgramaUniversidad.vue?vue&type=template&id=46b15beb&scoped=true"
import script from "./ModalFormularioEstablecerProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioEstablecerProgramaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioEstablecerProgramaUniversidad.vue?vue&type=style&index=0&id=46b15beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b15beb",
  null
  
)

export default component.exports